import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Alert, Button } from 'react-bootstrap'
import {
  cancelBusinessInfoModalDialog,
  closeBusinessInfoModalDialog,
  saveChangesBusinessInfoModalDialog,
  updateBusinessInformation,
  validateBusinessInfoModalDialog,
} from '../../actions/business_info_modal_dialog'
import validator from 'validator'
import TextFieldFormGroup from '../common/form/text_field_form_group'
import { FORM_VALIDATION_ERROR, FORM_VALIDATION_SUCCESS } from '../../config'
import { fetchBusinessById } from '../../actions/business'
import Spinner3Bounce from '../spinner_3_bounce'
import { toCamelCase } from '../../utils/helpers'

class BusinessInfoForm extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      name: null,
      nameValidationState: null,
      email: null,
      emailValidationState: null,
      ein: null,
    }
  }

  static compare(data = {}, stateData = {}) {
    let diff = {}
    for (let prop in data) {
      if (data.hasOwnProperty(prop)) {
        const oldValue = data[prop]
        const newProp = toCamelCase(prop)
        if (stateData.hasOwnProperty(newProp)) {
          const newValue = stateData[newProp]
          if (newValue !== null && newValue !== oldValue) {
            diff = { ...diff, [prop]: newValue }
          }
        }
      }
    }
    return diff
  }

  handleSaveChanges(e) {
    const { updateBusinessInformation, data, saveChangesBusinessInfoModalDialog } = this.props

    const outstandingValidationCount = Object.keys(this.state)
      .filter((element) => element.endsWith('ValidationState'))
      .filter((key) => this.state[key] === FORM_VALIDATION_ERROR).length

    if (outstandingValidationCount) {
      window.alert('Please check validation')
      return
    }

    // business info
    const infoData = BusinessInfoForm.compare(data, this.state)

    if (!Object.keys(infoData).length) {
      window.alert('Nothing to save - no changes detected')
      return
    }

    if (infoData && Object.keys(infoData).length) {
      updateBusinessInformation(data.id, infoData)
    }

    saveChangesBusinessInfoModalDialog(infoData)
  }

  static validate(value, required = false, validators = []) {
    if (required) {
      if (value.length < 1) {
        return 'error'
      }
    }

    if (value.length < 1) {
      return
    }

    for (let val in validators) {
      let result = true
      switch (validators[val]) {
        case 'isEmail':
          result = validator.isEmail(value)
          break
        case 'isLength':
          result = validator.isLength(value, { min: 3 })
          break
        default:
          throw Error('Invalid validator type')
      }
      if (value.length > 0 && !result) {
        return FORM_VALIDATION_ERROR
      }
    }
    return FORM_VALIDATION_SUCCESS
  }

  handleFieldChange(e, name, required = false, validators = []) {
    const value = e.target.value
    this.setState({ [name]: value })
    const result = BusinessInfoForm.validate(value, required, validators)
    this.setState({ [name + 'ValidationState']: result })
  }

  handleCloseModal(e) {
    const { fetchBusinessById, closeBusinessInfoModalDialog, data } = this.props
    fetchBusinessById(data.id)
    closeBusinessInfoModalDialog()
  }

  render() {
    const { data, cancelBusinessInfoModalDialog, isChangesSaved, isValidated, isSaving } = this.props

    let name = this.state.name
    if (this.state.name === null) {
      name = data.name || ''
    }

    let email = this.state.email
    if (this.state.email === null) {
      email = data.email || ''
    }

    let ein = this.state.ein
    if (this.state.ein === null) {
      ein = data.ein || ''
    }
    return (
      <form>
        {isSaving && (
          <div className='text-center grid-spinner-mt-60'>
            <Spinner3Bounce isActive />
          </div>
        )}
        {!isChangesSaved && !isSaving && (
          <div className='fadeOutDown'>
            <TextFieldFormGroup
              help='Required'
              value={name}
              controlId='name'
              controlLabel='Corporation Name'
              validationState={this.state.nameValidationState}
              handleFieldChange={(e) => this.handleFieldChange(e, 'name', true, ['isLength'])}
            />

            <TextFieldFormGroup
              value={ein}
              controlId='ein'
              controlLabel='Business ID number'
              handleFieldChange={(e) => this.handleFieldChange(e, 'ein', true, [])}
            />

            <TextFieldFormGroup
              value={email}
              controlId='email'
              controlLabel='E-mail'
              validationState={this.state.emailValidationState}
              handleFieldChange={(e) => this.handleFieldChange(e, 'email', false, ['isEmail'])}
            />
          </div>
        )}
        {isChangesSaved && !isSaving && (
          <Alert className='m-b-sm m-t-sm' variant='success'>
            Information has been successfully updated
          </Alert>
        )}
        <div className='text-end'>
          {isChangesSaved ? (
            <Button className='m-r-sm' onClick={(e) => this.handleCloseModal(e)}>
              Close
            </Button>
          ) : (
            <Button className='m-r-sm' onClick={() => cancelBusinessInfoModalDialog()}>
              Cancel
            </Button>
          )}
          {!isChangesSaved && isValidated && (
            <Button variant='primary' onClick={(e) => this.handleSaveChanges(e)}>
              Save changes
            </Button>
          )}
          {!isChangesSaved && !isValidated && (
            <Button disabled variant='primary' onClick={(e) => this.handleSaveChanges(e)}>
              Save changes
            </Button>
          )}
        </div>
      </form>
    )
  }
}

const mapStateToProps = (state) => ({
  isChangesSaved: state.businessInfoModalDialog.isChangesSaved,
  isValidated: state.businessInfoModalDialog.isValidated,
  isSaving: state.businessInfoModalDialog.isSaving,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      validateBusinessInfoModalDialog,
      closeBusinessInfoModalDialog,
      cancelBusinessInfoModalDialog,
      saveChangesBusinessInfoModalDialog,
      updateBusinessInformation,
      fetchBusinessById,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BusinessInfoForm))
